import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Spin } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IAddFeeStatusLookupListFormValues } from '../../../../../interfaces/lookup/feeStatus';
import { IAddFeeStatus } from '../../../../../interfaces/lookup/feeStatus/data';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { FetchResult } from '../../../../../shared/components/fetchResult/FetchResult';
import { ROW_GUTTER } from '../../../../../shared/Constants';
import { isError } from '../../../../../shared/helpers';
import { AppDispatch, RootState } from '../../../../../store';
import { addFeeStatus } from '../../../../../store/lookupSlice/LookupActions';

export const FeeStatusLookupListAdd = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const lookupSlice = useSelector((state: RootState) => state.lookupSlice);

    const onFinish = (values: IAddFeeStatusLookupListFormValues) => {
        const body: IAddFeeStatus = {
            ...(values as any),
        };

        dispatch(addFeeStatus(body));
    };

    useEffect(() => {
        if (lookupSlice.detailsPage.feeStatus.createStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/fee-status', { replace: true });
        }
    }, [lookupSlice.detailsPage.feeStatus.createStatus]);

    return (
        <Form
            form={form}
            name="feestatus-lookup-add"
            onFinish={onFinish}
            layout="vertical"
            onValuesChange={(changedValue: any, values) => {
                form.setFieldsValue(values);
            }}
        >
            <ContentHeader
                title="Manage fee statuses lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Fee status',
                        path: '/admin/lookup-lists/fee-status',
                    },
                    {
                        breadcrumbName: 'Create',
                        path: `/admin/lookup-lists/fee-status/add`,
                    },
                ]}
            >
                {!isError(lookupSlice.detailsPage.feeStatus.fetchStatus) && (
                    <Form.Item>
                        <Space>
                            <Button
                                icon={<CloseOutlined />}
                                onClick={() => navigate(-1)}
                                disabled={
                                    lookupSlice.detailsPage.feeStatus.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.feeStatus.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Close
                            </Button>
                            <Button
                                htmlType="submit"
                                type="primary"
                                icon={<SaveOutlined />}
                                loading={
                                    lookupSlice.detailsPage.feeStatus.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.feeStatus.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Save and close
                            </Button>
                        </Space>
                    </Form.Item>
                )}
            </ContentHeader>

            <div className="page-content">
                <Spin spinning={lookupSlice.detailsPage.feeStatus.fetchStatus === StatePieceStatus.IsFetching}>
                    {isError(lookupSlice.detailsPage.feeStatus.fetchStatus) ? (
                        <FetchResult status={lookupSlice.detailsPage.feeStatus.fetchStatus} about={'Fee status'} />
                    ) : (
                        <>
                            <Row>
                                <Col span={24}>
                                    <Space>
                                        <label className="group-label">Fee status option Information</label>
                                    </Space>
                                </Col>
                            </Row>
                            <Row gutter={ROW_GUTTER}>
                                <Col span={8}>
                                    <label className="property required">Code</label>
                                    <Form.Item name="code" rules={[{ required: true, message: "'Code' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <label className="property required">Description</label>
                                    <Form.Item name="description" rules={[{ required: true, message: "'Description' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>&nbsp;</Col>
                            </Row>
                        </>
                    )}
                </Spin>
            </div>
        </Form>
    );
};
